import styles from "@/common/SizeDropdown/SizeDropdown.module.scss";
import Dropdown from "../Dropdown";
import GiftCardCTA from "../GiftCardCTA";
import { useSelector } from "react-redux";
import { getCookie } from "cookies-next";
import { useState, useEffect } from "react";
import { sortSizes } from "@/helpers/pdpHelpers";

export default function GiftSizeDropdown({
  sizeVariants,
  selectedSize,
  setSelectedSize,
  isStickyDropdownOpen,
  showStickyDropdown,
  isSizeDropdownOpen,
  setIsSizeDropdownOpen,
  AddToBag,
}) {
  let sizeData = [];
  let disabled = [];
  let dropdownTitle = selectedSize ? "Selected amount" : "Select gift amount";
  let innerDropUpTitle="Select gift amount";
  for (const size in sizeVariants) {
    if (sizeVariants.hasOwnProperty(size)) {
      if(parseInt(sizeVariants[size].priceV2.amount)!=0)
      {
        sizeData.push(size);
      }
      if (!sizeVariants[size].availableForSale) disabled.push(size);
    }
  }
  // const isOneSize = sizeData.length === 1;
  sortSizes(sizeData);

  const handleDropdownToggle = (e) => {
    setIsSizeDropdownOpen(e);
  };

  
  const [loading, setLoading] = useState(false);

  const isWishlistLoading = useSelector(
    (state) => state.wishlist.loading_status
  );

  useEffect(() => {
    if (isWishlistLoading) {
      if (getCookie("isFavourite")) {
        setLoading(true);
      }
    } else {
      setLoading(false);
    }
  }, [isWishlistLoading]);

  return (
    <>
      {(
      
          <Dropdown
            ArrowDown="images/Icons/Chevron/large.svg"
            data={sizeData}
            disabled={disabled}
            selected={selectedSize}
            setSelected={setSelectedSize}
            isStickyDropdownOpen={isStickyDropdownOpen}
            showStickyDropdown={showStickyDropdown}
            isDropdownOpen={isSizeDropdownOpen}
            parentHandleToggle={handleDropdownToggle}
            selectedSize={selectedSize}
            isDropup={true}
            AddToBag={AddToBag}
            dropdownTitle={dropdownTitle}
            loading={loading}
            mobileSizeComp={<GiftCardCTA AddToBag={AddToBag}/>}
            innerDropUpTitle={innerDropUpTitle}
            isGiftDropup={true}
          />
      
      )}
    </>
  );
}
